import PageHeading from '../../components/PageHeading';
import React, { Component } from 'react';
import Filters from '../../components/Filters';
import { Col, Row } from 'reactstrap';
import './styles.scss';
import OrderList from '../../components/OrderList';
import StatisticsWidget from '../../components/StatisticsWidget';
import { LazyPage } from '../../components/LazyPage';

export default class MyOrdersPage extends Component {
  render() {
    return (
      <LazyPage>
        <PageHeading>Мои заказы</PageHeading>
        <Filters/>

        <Row>
          <Col xs>
            <OrderList/>
            <StatisticsWidget/>
          </Col>
        </Row>
      </LazyPage>
    );
  }
}
